var map = {
	"./Adolfo/acerca-de-mi/image0.jpeg": 49375,
	"./Adolfo/acerca-de-mi/image1.jpeg": 81715,
	"./Adolfo/acerca-de-mi/image1.png": 23088,
	"./Adolfo/acerca-de-mi/image3.jpeg": 39149,
	"./Adolfo/acerca-de-mi/image4.png": 4396,
	"./Adolfo/banner/bg-banner.jpg": 14281,
	"./Adolfo/enfermedades/Polipos.png": 92372,
	"./Adolfo/enfermedades/Reconexiones intestinales.png": 64493,
	"./Adolfo/enfermedades/absecos anorrectales.png": 66552,
	"./Adolfo/enfermedades/apendicitis.png": 48986,
	"./Adolfo/enfermedades/cancer-de-colon.png": 8059,
	"./Adolfo/enfermedades/colitis.png": 26413,
	"./Adolfo/enfermedades/condiloma.png": 34145,
	"./Adolfo/enfermedades/diverticulitis.png": 39039,
	"./Adolfo/enfermedades/dolor-anal.png": 28187,
	"./Adolfo/enfermedades/estomas.png": 9598,
	"./Adolfo/enfermedades/fisura-anal.png": 39246,
	"./Adolfo/enfermedades/fístulas anales.png": 17852,
	"./Adolfo/enfermedades/hemorroides.png": 19936,
	"./Adolfo/enfermedades/hernia-abdominal.png": 21491,
	"./Adolfo/enfermedades/hernia-inguinal.png": 32348,
	"./Adolfo/enfermedades/hernia-umbilical.png": 78677,
	"./Adolfo/enfermedades/incontingencia-fecal.png": 79953,
	"./Adolfo/enfermedades/intestino-inflamacion.png": 45085,
	"./Adolfo/enfermedades/piedras vesicula.png": 96283,
	"./Adolfo/enfermedades/prolapso-rectal.png": 98467,
	"./Adolfo/enfermedades/prurito-anal.png": 87364,
	"./Adolfo/enfermedades/quiste.png": 64815,
	"./Adolfo/enfermedades/recto-vaginal.png": 46161,
	"./Adolfo/enfermedades/sangrado intestinal.png": 60325,
	"./Adolfo/enfermedades/urgencias quirúrgicas.png": 5296,
	"./Adolfo/iconos/cirugia-plastica.png": 63047,
	"./Adolfo/iconos/cuarto-de-cirugia.png": 30770,
	"./Adolfo/iconos/estomago.png": 80125,
	"./Adolfo/iconos/intestino.png": 20966,
	"./Adolfo/inicio/image10.png": 80173,
	"./Adolfo/inicio/image10_preview_rev_1.png": 69047,
	"./Adolfo/inicio/image5.png": 27874,
	"./Adolfo/inicio/image5_preview_rev_1.png": 66669,
	"./Adolfo/logo/doctor-sidebar-bg.jpg": 49024,
	"./Adolfo/logo/logo.png": 43359,
	"./Adolfo/servicios/ImagenMission.jpeg": 41133,
	"./Adolfo/servicios/cirgugialaparoscopica.png": 74968,
	"./Adolfo/servicios/cirugiaabierta.png": 69657,
	"./Adolfo/servicios/cirugiarobotica.png": 87842,
	"./Adolfo/servicios/colonoscopia.png": 22887,
	"./Adolfo/servicios/consultaespecializada.png": 48486,
	"./Adolfo/servicios/especialidades.png": 2224,
	"./about-img1.jpg": 86249,
	"./about-img2.jpg": 11408,
	"./about-img3.jpg": 63338,
	"./aboutus-fift-1.jpg": 34819,
	"./app-bg.png": 99770,
	"./app-img.svg": 49328,
	"./app-store-1.png": 91578,
	"./app-store.png": 20258,
	"./appointment-front-icon1.png": 77946,
	"./appointment-front-icon2.png": 69693,
	"./appointment-front-icon3.png": 66291,
	"./appointment-ryt-1.png": 82143,
	"./ban-fift-icon1.png": 24676,
	"./ban-fift-icon2.png": 71004,
	"./ban-fift-icon3.png": 59941,
	"./ban-fift-icon4.png": 61952,
	"./ban-fift-icon5.png": 44855,
	"./ban-fift-icon6.png": 17554,
	"./ban-fift-icon7.png": 45767,
	"./ban-fift-icon8.png": 10597,
	"./ban-right-img1.jpg": 81558,
	"./ban-right-img2.jpg": 16199,
	"./ban-sixteen-img1.png": 830,
	"./ban-sixteen-img2.png": 49351,
	"./banner-1.png": 18129,
	"./banner-11.png": 62967,
	"./banner-2.jpg": 7861,
	"./banner-3.jpg": 34070,
	"./banner-bg-icon1.png": 8865,
	"./banner-bg-icon2.png": 63398,
	"./banner-bg-icon3.png": 85179,
	"./banner-bg.png": 54927,
	"./banner-cluoud-01.png": 57523,
	"./banner-cluoud-02.png": 81251,
	"./banner-curve-bg.png": 56972,
	"./banner-fifteen-ryt.png": 29302,
	"./banner-fifteen-vd.jpg": 11587,
	"./banner-fifteen.png": 92658,
	"./banner-img-13.png": 43280,
	"./banner-img-curve-13.png": 24291,
	"./banner-img.png": 39453,
	"./banner-img1.png": 68527,
	"./banner-img2.png": 67148,
	"./banner-img3.png": 97571,
	"./banner-lief-img.png": 82223,
	"./banner-round-vector-13.png": 61981,
	"./banner-six-2.png": 7039,
	"./banner-sixteen-bg.png": 18048,
	"./banner/banner-05.png": 80496,
	"./banner/banner-051.jpg": 38649,
	"./banner/banner-img1.svg": 67089,
	"./banner/banner-img2.svg": 28656,
	"./banner/banner-img3.svg": 80579,
	"./banner/dentist-banner-bg-01.jpg": 55427,
	"./banner/dentist-banner-bg-01.png": 15317,
	"./banner/dentist-banner-bg-02.png": 55319,
	"./banner/dentist-banner-bg-03.png": 34386,
	"./banner/dentist-banner-bg-04.png": 59606,
	"./banner/dentist-banner-bg-05.png": 66537,
	"./banner/doctor-banner-01.jpg": 64744,
	"./banner/doctor-banner.png": 14093,
	"./bg/Map-thirteen.png": 61505,
	"./bg/app-bg-01.png": 12013,
	"./bg/app-bg.jpg": 48629,
	"./bg/app-bg.png": 16920,
	"./bg/appoint-bg.png": 66097,
	"./bg/article-bg.png": 79342,
	"./bg/atom-bond.png": 6396,
	"./bg/baby-star.png": 27585,
	"./bg/ban-bg-01.png": 37700,
	"./bg/ban-bg-02.png": 30099,
	"./bg/ban-bg.png": 93768,
	"./bg/banner-11-bg.png": 15916,
	"./bg/banner-bg.png": 75955,
	"./bg/banner-clip.png": 30048,
	"./bg/banner-sec-bg-13.jpg": 4594,
	"./bg/banner-sec-bg-13.png": 56294,
	"./bg/benefit-bg.png": 7123,
	"./bg/best-quality-sec-img.png": 51777,
	"./bg/bg-curve-vector.png": 57939,
	"./bg/big-paw.png": 46042,
	"./bg/blog-bg-14.png": 97652,
	"./bg/blue-rainbow.png": 10693,
	"./bg/blue-star.png": 75023,
	"./bg/blue-vector-bg-01.png": 47815,
	"./bg/blue-vector-bg-02.png": 98560,
	"./bg/card-bg-small.png": 50021,
	"./bg/cardiac-bg-02.png": 72692,
	"./bg/cardiac-bg.png": 93439,
	"./bg/care-bg-01.png": 58689,
	"./bg/care-bg-02.png": 40644,
	"./bg/care-bg.png": 28555,
	"./bg/care-sec-bg-1.png": 20108,
	"./bg/center-bg.png": 38508,
	"./bg/chart-arrow-01.png": 31316,
	"./bg/chart-arrow-02.png": 24757,
	"./bg/circle-bg.png": 56301,
	"./bg/clients-says.jpg": 51472,
	"./bg/clinic-bg-01.png": 64387,
	"./bg/cloud-1.png": 26098,
	"./bg/cloud-2.png": 59926,
	"./bg/core-bg.png": 24507,
	"./bg/cosmetics-banner-bg.png": 20387,
	"./bg/counter-bg-01-.png": 67060,
	"./bg/counter-bg-01.png": 55537,
	"./bg/counter-bg-02.png": 13740,
	"./bg/counter-bg.png": 92095,
	"./bg/dashboard-circle-bg.png": 17434,
	"./bg/dental-bg.png": 30198,
	"./bg/dental-shape.png": 145,
	"./bg/dentist-bg.png": 73844,
	"./bg/dentist-visit-bg.png": 91453,
	"./bg/doc-shape-01.png": 34827,
	"./bg/doc-shape-02.png": 1861,
	"./bg/doctor-bg.jpg": 3026,
	"./bg/doctor-bg.png": 63377,
	"./bg/doctor-shape-img1.png": 95888,
	"./bg/doctor-shape-img2.png": 58641,
	"./bg/dog-img.png": 10211,
	"./bg/dot-1.png": 54545,
	"./bg/dot-2.png": 52010,
	"./bg/ecg-wave.png": 94959,
	"./bg/ecg.png": 24087,
	"./bg/ent-banner-bg-01.png": 17211,
	"./bg/ent-banner-bg-02.png": 1420,
	"./bg/expert-sec-bg-01.png": 17184,
	"./bg/expert-sec-bg-02.png": 61689,
	"./bg/eye-card-bg-01.png": 42387,
	"./bg/eye-card-bg-02.png": 19225,
	"./bg/eye-card-bg-03.png": 1193,
	"./bg/eye-card-bg-04.png": 43583,
	"./bg/eyecare-home-bg-01.png": 17827,
	"./bg/feedback-six.png": 20500,
	"./bg/footer-bg.png": 77971,
	"./bg/footer-map.jpg": 16370,
	"./bg/footer-round-bg.png": 24264,
	"./bg/gold-star.png": 36762,
	"./bg/hand.png": 74815,
	"./bg/header-after.png": 96073,
	"./bg/header-bg.png": 29280,
	"./bg/health-care.png": 96875,
	"./bg/heart-1.png": 69779,
	"./bg/heart-banner-bg.png": 24756,
	"./bg/heart-bg.png": 97878,
	"./bg/heart-in-hand.png": 75032,
	"./bg/heart-plus.png": 94449,
	"./bg/hexagen-group-1.png": 57122,
	"./bg/hexagen-group-3.png": 55804,
	"./bg/hexagen-group-4.png": 54,
	"./bg/hexagen-group-5.png": 52006,
	"./bg/hexagon-group-2.png": 88690,
	"./bg/home-10-banner-img.png": 50720,
	"./bg/home-10-banner.png": 81018,
	"./bg/home-12-banner-1.png": 55067,
	"./bg/home-12-banner-2.png": 43068,
	"./bg/home-12-banner-bg-1.png": 65738,
	"./bg/home-12-banner-bg-2.png": 19907,
	"./bg/home-12-pricing-bg-1.png": 50948,
	"./bg/home-12-pricing-bg-2.png": 50682,
	"./bg/home-12-pricing-bg-3.png": 5596,
	"./bg/home-12-pricing-bg-4.png": 87220,
	"./bg/home-12-pricing-bg-5.png": 29326,
	"./bg/home-12-testimonial.png": 58136,
	"./bg/home-12-why-us.png": 24778,
	"./bg/home-13-banner-img.png": 23129,
	"./bg/home-13-banner.png": 47446,
	"./bg/logo.svg": 75621,
	"./bg/map.png": 56823,
	"./bg/online-bg.png": 87150,
	"./bg/our-store-bg.png": 16073,
	"./bg/package-card-bg-01.png": 52242,
	"./bg/package-card-bg-02.png": 46120,
	"./bg/package-card-bg-03.png": 70827,
	"./bg/pink-star.png": 74401,
	"./bg/plan-bg-01.png": 8868,
	"./bg/plan-bg-02.png": 37993,
	"./bg/pluse-1.png": 56799,
	"./bg/pluse-2.png": 33458,
	"./bg/pluse-3.png": 4424,
	"./bg/pluse-4.png": 65480,
	"./bg/pluse-white.png": 99519,
	"./bg/price-sec-bg-01.png": 79622,
	"./bg/price-sec-bg.png": 51688,
	"./bg/price-sec-paw-01.png": 28973,
	"./bg/price-sec-paw-02.png": 195,
	"./bg/pricing-bg.png": 47023,
	"./bg/pulse-6.png": 12064,
	"./bg/pulse-7.png": 93602,
	"./bg/rainbow-2.png": 11139,
	"./bg/rectangle-bg.png": 42226,
	"./bg/ring-1.png": 16802,
	"./bg/ring-2.png": 88783,
	"./bg/round-tablet-bg.png": 98222,
	"./bg/rounded-circle-01.png": 21746,
	"./bg/rounded-circle-02.png": 30515,
	"./bg/safe-bg-01.png": 62715,
	"./bg/safe-bg-02.png": 60056,
	"./bg/sec-bg-line.png": 97557,
	"./bg/section-bg-01.jpg": 51163,
	"./bg/section-bg-02.png": 76026,
	"./bg/section-bg-03.png": 38557,
	"./bg/section-bg-04.png": 89859,
	"./bg/section-bg-05.png": 91513,
	"./bg/sercice-sec-bg.png": 69433,
	"./bg/serv-img-01.png": 65412,
	"./bg/serv-img-02.png": 19122,
	"./bg/service-bg-01.png": 44248,
	"./bg/service-bg-02.png": 1712,
	"./bg/service-bg-icon.png": 7879,
	"./bg/service-bg.png": 65571,
	"./bg/slider-bg-img.png": 37223,
	"./bg/small-paw-2.png": 86025,
	"./bg/small-paw-3.png": 4369,
	"./bg/small-paw.png": 48945,
	"./bg/speciality-bg-01.png": 18626,
	"./bg/star-1.png": 54150,
	"./bg/steps-bg-02.png": 40735,
	"./bg/steps-bg.png": 21482,
	"./bg/store-bg-01.png": 51586,
	"./bg/store-bg.png": 79348,
	"./bg/tablet-bg.png": 54036,
	"./bg/testi-bg.png": 40137,
	"./bg/testi-left-bg.png": 24852,
	"./bg/testi-right-bg.png": 19709,
	"./bg/testi-round-bg.png": 25402,
	"./bg/title-bg.png": 80833,
	"./bg/two-paw.png": 72185,
	"./bg/update-bg-01.png": 92029,
	"./bg/update-bg.png": 83757,
	"./bg/vector-bg-01.png": 49303,
	"./bg/vector-bg-02.png": 11430,
	"./bg/vector-bg-03.png": 77762,
	"./bg/vector-bg-04.png": 71399,
	"./bg/vector-bg-05.png": 92484,
	"./bg/vector-bg-06.png": 68319,
	"./bg/veterinary-care-bg.png": 42665,
	"./bg/veterinary-home-bg.png": 10658,
	"./bg/veterinary-pg-sec-icon-1.png": 39669,
	"./bg/veterinary-pg-sec-icon-2.png": 55445,
	"./bg/veterinary-pg-sec-icon-3.png": 32596,
	"./bg/video-sec-bg.png": 55440,
	"./bg/visit-bg.png": 39962,
	"./bg/wave.svg": 26800,
	"./blog-1.jpg": 40375,
	"./blog-2.jpg": 24461,
	"./blog-3.jpg": 87558,
	"./blog-4.jpg": 85836,
	"./blog/blog-01.jpg": 81077,
	"./blog/blog-02.jpg": 36417,
	"./blog/blog-03.jpg": 38205,
	"./blog/blog-04.jpg": 62093,
	"./blog/blog-05.jpg": 64208,
	"./blog/blog-06.jpg": 60522,
	"./blog/blog-07.jpg": 74420,
	"./blog/blog-08.jpg": 90882,
	"./blog/blog-09.jpg": 26284,
	"./blog/blog-10.jpg": 35029,
	"./blog/blog-11.jpg": 83735,
	"./blog/blog-12.jpg": 46009,
	"./blog/blog-13.jpg": 10261,
	"./blog/blog-14.jpg": 85632,
	"./blog/blog-15.jpg": 36400,
	"./blog/blog-16.jpg": 64786,
	"./blog/blog-17.jpg": 24798,
	"./blog/blog-18.jpg": 7629,
	"./blog/blog-19.jpg": 74034,
	"./blog/blog-20.jpg": 74246,
	"./blog/blog-21.jpg": 22459,
	"./blog/blog-22.jpg": 48022,
	"./blog/blog-23.jpg": 97265,
	"./blog/blog-24.jpg": 45718,
	"./blog/blog-25.jpg": 92762,
	"./blog/blog-26.jpg": 39239,
	"./blog/blog-27.jpg": 23585,
	"./blog/blog-28.jpg": 28206,
	"./blog/blog-29.jpg": 42562,
	"./blog/blog-30.jpg": 28052,
	"./blog/blog-31.jpg": 34054,
	"./blog/blog-thumb-01.jpg": 76778,
	"./blog/blog-thumb-02.jpg": 49930,
	"./blog/blog-thumb-03.jpg": 756,
	"./blog/blog-thumb-04.jpg": 97340,
	"./blog/blog-thumb-05.jpg": 38587,
	"./blog/blog-thumb-06.jpg": 3791,
	"./blog/blog-thumb-07.jpg": 56410,
	"./blog/blog-thumb-08.jpg": 45036,
	"./blog/blog-thumb-09.jpg": 46397,
	"./blog/blog-thumb-10.jpg": 98475,
	"./blog/blog-wrap-01.jpg": 37389,
	"./blog/blog-wrap-02.jpg": 3189,
	"./blog/blog-wrap-03.jpg": 74247,
	"./blog/blog-wrap-04.jpg": 86166,
	"./blog/book-lab-01.jpg": 23653,
	"./blog/book-lab-02.jpg": 27602,
	"./blog/book-lab-03.jpg": 29127,
	"./blog/cardio-blog-01.jpg": 94706,
	"./blog/cardio-blog-02.jpg": 8760,
	"./blog/cardio-blog-03.jpg": 90140,
	"./blog/cardio-blog-04.jpg": 7882,
	"./blog/dentist-blog-01.jpg": 71357,
	"./blog/dentist-blog-02.jpg": 92245,
	"./blog/dentist-blog-03.jpg": 76299,
	"./blog/eye-blog-01.jpg": 49789,
	"./blog/eye-blog-02.jpg": 54715,
	"./blog/eye-blog-03.jpg": 64891,
	"./blog/eye-blog-04.jpg": 95969,
	"./blog/fertility-blog-01.jpg": 92493,
	"./blog/veterinary-blog-01.jpg": 65128,
	"./blog/veterinary-blog-02.jpg": 20592,
	"./blog/veterinary-blog-03.jpg": 25946,
	"./book-appointment-bg.png": 22011,
	"./category/1.png": 42898,
	"./category/2.png": 20014,
	"./category/3.png": 87302,
	"./category/4.png": 85528,
	"./category/5.png": 23787,
	"./category/6.png": 6924,
	"./category/7.png": 20494,
	"./category/8.png": 2301,
	"./category/categorie-01.jpg": 1610,
	"./category/categorie-01.png": 3851,
	"./category/categorie-02.jpg": 79987,
	"./category/categorie-02.png": 5779,
	"./category/categorie-03.jpg": 65629,
	"./category/categorie-03.png": 86523,
	"./category/categorie-04.jpg": 32320,
	"./category/categorie-04.png": 44325,
	"./category/categorie-05.jpg": 33548,
	"./category/categorie-05.png": 66906,
	"./category/categorie-06.jpg": 36781,
	"./category/categorie-06.png": 79565,
	"./category/categorie-07.jpg": 44025,
	"./category/categorie-07.png": 27591,
	"./category/categorie-08.jpg": 21037,
	"./category/categorie-08.png": 14142,
	"./category/categorie-09.jpg": 19874,
	"./category/categorie-09.png": 10027,
	"./category/categorie-10.jpg": 81205,
	"./category/categorie-10.png": 4196,
	"./category/categorie-11.jpg": 73749,
	"./category/categorie-11.png": 33417,
	"./category/categorie-12.jpg": 17625,
	"./category/categorie-12.png": 77411,
	"./category/category-01.svg": 62985,
	"./category/category-02.svg": 69318,
	"./category/category-03.svg": 9360,
	"./category/category-04.svg": 90395,
	"./category/category-05.svg": 80625,
	"./category/category-06.svg": 21971,
	"./category/doc-sel-01.jpg": 3672,
	"./check.png": 64701,
	"./choose-img.jpg": 29310,
	"./choose-us-six.png": 87380,
	"./chooseus-ryt-1.png": 95048,
	"./chooseus-ryt-2.png": 67050,
	"./clients/client-01.jpg": 17730,
	"./clients/client-02.jpg": 81367,
	"./clients/client-03.jpg": 18267,
	"./clients/client-04.jpg": 55285,
	"./clients/client-05.jpg": 71631,
	"./clients/client-06.jpg": 21379,
	"./clients/client-07.jpg": 93244,
	"./clients/client-08.jpg": 55913,
	"./clients/client-09.jpg": 20095,
	"./clients/client-10.jpg": 90126,
	"./clients/client-11.jpg": 45355,
	"./clients/client-12.jpg": 32892,
	"./clients/client-13.jpg": 99398,
	"./clients/client-14.jpg": 93653,
	"./clients/client-15.jpg": 36216,
	"./clients/client-16.jpg": 16216,
	"./clients/re-image-1.jpg": 20029,
	"./clients/re-image-2.jpg": 11630,
	"./clients/re-image-3.jpg": 94404,
	"./clients/re-image-4.jpg": 34917,
	"./clients/re-image-5.jpg": 5206,
	"./clients/re-image-6.jpg": 64917,
	"./clients/re-image-7.jpg": 43520,
	"./clients/re-image-8.jpg": 34502,
	"./clients/re-image-9.jpg": 67903,
	"./clinic/clinic-01.png": 48456,
	"./clinic/clinic-02.png": 13471,
	"./clinic/clinic-03.png": 68309,
	"./clinic/clinic-04.png": 83507,
	"./clinic/clinic-05.png": 19175,
	"./clinic/clinic-06.png": 2180,
	"./clinic/clinic-1.jpg": 17294,
	"./clinic/clinic-10.jpg": 39240,
	"./clinic/clinic-11.jpg": 64110,
	"./clinic/clinic-12.jpg": 57989,
	"./clinic/clinic-2.jpg": 77062,
	"./clinic/clinic-3.jpg": 71041,
	"./clinic/clinic-4.jpg": 43398,
	"./clinic/clinic-5.jpg": 10083,
	"./clinic/clinic-6.jpg": 98697,
	"./clinic/clinic-7.jpg": 83841,
	"./clinic/clinic-8.jpg": 21657,
	"./clinic/clinic-9.jpg": 99685,
	"./clinic/service-1.jpg": 87077,
	"./clinic/service-2.jpg": 39266,
	"./clinic/service-3.jpg": 19342,
	"./clinic/service-4.jpg": 61896,
	"./clinic/service-5.jpg": 51813,
	"./clinic/service-6.jpg": 86987,
	"./clinic/spec-01.jpg": 99726,
	"./clinic/spec-02.jpg": 79826,
	"./clinic/spec-03.jpg": 74176,
	"./cloud-bg.png": 9320,
	"./coming-soon.png": 93936,
	"./contact-fourteen.png": 25720,
	"./contact-icon2.png": 74790,
	"./contact-icon3.png": 29748,
	"./cosmetic-banner-img.png": 57801,
	"./cosmetic-banner-img1.png": 14129,
	"./cosmetic-banner-img2.png": 13365,
	"./cosmetic-banner-img3.png": 64407,
	"./cosmetic-banner-img4.png": 55341,
	"./deals/deals-01.png": 35737,
	"./deals/deals-02.png": 85425,
	"./deals/deals-03.png": 98072,
	"./deals/deals-04.png": 887,
	"./deals/deals-05.png": 95995,
	"./deals/deals-06.png": 97899,
	"./deals/deals-07.png": 70696,
	"./deals/deals-08.png": 46816,
	"./deals/deals-09.jpg": 60695,
	"./dentist-01.jpg": 76415,
	"./dentist-02.jpg": 26775,
	"./dentist-home-logo.svg": 68757,
	"./dependent/dependent-01.jpg": 18519,
	"./dependent/dependent-02.jpg": 30750,
	"./dependent/dependent-03.jpg": 79577,
	"./dependent/dependent-04.jpg": 81149,
	"./doc-slide-1.png": 81532,
	"./doctor-banner.png": 52171,
	"./doctor-banner1.png": 70268,
	"./doctor-profiles/doc-profile-01.jpg": 31657,
	"./doctor-profiles/doc-profile-02.jpg": 89695,
	"./doctor-profiles/doc-profile-03.jpg": 36642,
	"./doctor-profiles/doc-profile-04.jpg": 40140,
	"./doctor-profiles/doc-profile-05.jpg": 90530,
	"./doctor-profiles/doc-profile-06.jpg": 43907,
	"./doctor-profiles/doc-profile-07.jpg": 49155,
	"./doctor-profiles/doc-profile-08.jpg": 90345,
	"./doctor-profiles/doc-profile-09.jpg": 51529,
	"./doctor-profiles/doc-profile-10.jpg": 38010,
	"./doctors-dashboard/clinic-01.jpg": 8496,
	"./doctors-dashboard/clinic-02.jpg": 66836,
	"./doctors-dashboard/doctor-profile-img.jpg": 28535,
	"./doctors-dashboard/doctor-sidebar-bg.jpg": 6594,
	"./doctors-dashboard/patient-sidebar-bg.jpg": 31233,
	"./doctors-dashboard/profile-01.jpg": 75043,
	"./doctors-dashboard/profile-02.jpg": 11641,
	"./doctors-dashboard/profile-03.jpg": 18658,
	"./doctors-dashboard/profile-04.jpg": 34765,
	"./doctors-dashboard/profile-05.jpg": 87896,
	"./doctors-dashboard/profile-06.jpg": 46791,
	"./doctors-dashboard/profile-07.jpg": 76917,
	"./doctors-dashboard/profile-08.jpg": 7561,
	"./doctors/adolfo-perfil-1.jpg": 75818,
	"./doctors/book-doc-01.jpg": 61429,
	"./doctors/book-doc-02.jpg": 94130,
	"./doctors/book-doc-03.jpg": 10923,
	"./doctors/book-doc-04.jpg": 93168,
	"./doctors/book-doc-05.jpg": 59389,
	"./doctors/dentist-doctor-01.jpg": 56257,
	"./doctors/dentist-doctor-02.jpg": 44174,
	"./doctors/dentist-doctor-03.jpg": 15353,
	"./doctors/dentist-doctor-04.jpg": 98066,
	"./doctors/dentist-doctor-05.jpg": 86594,
	"./doctors/dentist-doctor-06.jpg": 41118,
	"./doctors/doc-profile-02.jpg": 30509,
	"./doctors/doc-profile-img.jpg": 24144,
	"./doctors/doctor-01.jpg": 27616,
	"./doctors/doctor-02.jpg": 15852,
	"./doctors/doctor-03.jpg": 9251,
	"./doctors/doctor-04.jpg": 8846,
	"./doctors/doctor-05.jpg": 64482,
	"./doctors/doctor-06.jpg": 19621,
	"./doctors/doctor-07.jpg": 40068,
	"./doctors/doctor-08.jpg": 22593,
	"./doctors/doctor-09.jpg": 64595,
	"./doctors/doctor-10.jpg": 61975,
	"./doctors/doctor-11.jpg": 98065,
	"./doctors/doctor-12.jpg": 64562,
	"./doctors/doctor-13.jpg": 88118,
	"./doctors/doctor-14.jpg": 81799,
	"./doctors/doctor-15.jpg": 21167,
	"./doctors/doctor-16.jpg": 14150,
	"./doctors/doctor-17.jpg": 46813,
	"./doctors/doctor-18.jpg": 88501,
	"./doctors/doctor-19.jpg": 16272,
	"./doctors/doctor-20.jpg": 17110,
	"./doctors/doctor-21.jpg": 31965,
	"./doctors/doctor-22.jpg": 57890,
	"./doctors/doctor-23.jpg": 46792,
	"./doctors/doctor-24.jpg": 67741,
	"./doctors/doctor-25.png": 31443,
	"./doctors/doctor-26.png": 16529,
	"./doctors/doctor-27.png": 81422,
	"./doctors/doctor-28.jpg": 18895,
	"./doctors/doctor-29.jpg": 28130,
	"./doctors/doctor-30.jpg": 87945,
	"./doctors/doctor-thumb-01.jpg": 65213,
	"./doctors/doctor-thumb-02.jpg": 99353,
	"./doctors/doctor-thumb-03.jpg": 5617,
	"./doctors/doctor-thumb-04.jpg": 28829,
	"./doctors/doctor-thumb-05.jpg": 19207,
	"./doctors/doctor-thumb-06.jpg": 39281,
	"./doctors/doctor-thumb-07.jpg": 92541,
	"./doctors/doctor-thumb-08.jpg": 19015,
	"./doctors/doctor-thumb-09.jpg": 34620,
	"./doctors/doctor-thumb-10.jpg": 81314,
	"./doctors/doctor-thumb-11.jpg": 82998,
	"./doctors/doctor-thumb-12.jpg": 79026,
	"./doctors/doctor-thumb-13.jpg": 2918,
	"./doctors/doctor-thumb-14.jpg": 44206,
	"./doctors/doctor-thumb-15.jpg": 80791,
	"./doctors/doctor-thumb-16.jpg": 8251,
	"./doctors/doctor-thumb-17.jpg": 62247,
	"./doctors/doctor-thumb-18.jpg": 49716,
	"./doctors/doctor-thumb-19.jpg": 93633,
	"./doctors/doctor-thumb-20.jpg": 19184,
	"./doctors/doctor-thumb-21.jpg": 8587,
	"./doctors/eye-doctor-01.jpg": 59568,
	"./doctors/eye-doctor-02.jpg": 41849,
	"./doctors/eye-doctor-03.jpg": 50400,
	"./doctors/eye-doctor-04.jpg": 85381,
	"./doctors/eye-doctor-05.jpg": 75401,
	"./doctors/eye-special-doc-01.jpg": 56434,
	"./doctors/eye-special-doc-02.jpg": 3343,
	"./doctors/eye-special-doc-03.jpg": 18545,
	"./doctors/fertility-doc-01.jpg": 63075,
	"./doctors/fertility-doc-02.jpg": 97865,
	"./doctors/fertility-doc-03.jpg": 96591,
	"./doctors/fertility-doc-04.jpg": 95791,
	"./doctors/fertility-doc-05.jpg": 43858,
	"./doctors/fertility-doc-06.jpg": 7829,
	"./doctors/lab-doctor.jpg": 32958,
	"./doctors/veterinary-doctor-01.jpg": 93015,
	"./doctors/veterinary-doctor-02.jpg": 82818,
	"./doctors/veterinary-doctor-03.jpg": 16907,
	"./doctors/veterinary-doctor-04.jpg": 16138,
	"./doctors/veterinary-doctor-05.jpg": 65807,
	"./doctors/veterinary-doctor-06.jpg": 31319,
	"./doctors/veterinary-doctor-07.jpg": 87080,
	"./doctors/veterinary-doctor-08.jpg": 81770,
	"./down-arrow-img.png": 43781,
	"./dr-slider.png": 19325,
	"./error-404.png": 15110,
	"./error-500.png": 33634,
	"./experts-1.jpg": 34235,
	"./experts-2.jpg": 31364,
	"./experts-3.jpg": 56436,
	"./eye.png": 78460,
	"./faq-img-2.png": 37763,
	"./faq-img-3.png": 79053,
	"./faq-img.png": 81301,
	"./faq-sec-img-01.png": 38380,
	"./faq-sec-img-02.png": 17908,
	"./faq-sec-img-03.png": 8523,
	"./faq-sec-img-04.png": 60783,
	"./faq-sec-img.jpg": 96857,
	"./faq/faq-01.jpg": 95958,
	"./favicon.png": 24184,
	"./feature-service-1.jpg": 20187,
	"./feature-service-2.jpg": 92561,
	"./feature-service-3.jpg": 2313,
	"./featured-bg.jpg": 49927,
	"./features/facility-01.jpg": 71564,
	"./features/facility-02.jpg": 70594,
	"./features/facility-03.jpg": 13781,
	"./features/facility-04.jpg": 76357,
	"./features/facility-05.jpg": 47595,
	"./features/facility-06.jpg": 50421,
	"./features/facility-07.jpg": 98197,
	"./features/feature-01.jpg": 763,
	"./features/feature-02.jpg": 2021,
	"./features/feature-03.jpg": 25548,
	"./features/feature-04.jpg": 64307,
	"./features/feature-05.jpg": 85405,
	"./features/feature-06.jpg": 46710,
	"./features/feature-07.jpg": 56045,
	"./features/feature-08.jpg": 45059,
	"./features/feature-09.jpg": 36302,
	"./features/feature-10.jpg": 22355,
	"./features/feature-11.jpg": 7764,
	"./features/feature-12.jpg": 3351,
	"./features/feature-13.jpg": 71086,
	"./features/feature-14.jpg": 381,
	"./features/feature-15.jpg": 24433,
	"./features/feature-16.jpg": 5414,
	"./features/feature.png": 23449,
	"./features/package-card-img-01.png": 72400,
	"./features/package-card-img-01.svg": 43382,
	"./features/package-card-img-02.png": 65702,
	"./features/package-card-img-02.svg": 52843,
	"./features/package-card-img-03.png": 99935,
	"./features/package-card-img-03.svg": 93053,
	"./feedback-bg.png": 24603,
	"./feedback-fifteen.png": 53452,
	"./feedback-inner.png": 15012,
	"./feedback-six.png": 16350,
	"./feedback-sixteen.png": 57416,
	"./fifteen-bg-icon-1.png": 20873,
	"./fifteen-bg-icon-2.png": 98348,
	"./fifteen-bg-icon-3.png": 43407,
	"./first-visit.png": 80718,
	"./flags/ad.png": 2825,
	"./flags/ae.png": 7635,
	"./flags/af.png": 34664,
	"./flags/ag.png": 48118,
	"./flags/ai.png": 7658,
	"./flags/al.png": 27632,
	"./flags/am.png": 93941,
	"./flags/ao.png": 54255,
	"./flags/ar.png": 80115,
	"./flags/as.png": 99070,
	"./flags/at.png": 73632,
	"./flags/au.png": 57193,
	"./flags/aw.png": 58349,
	"./flags/ax.png": 5432,
	"./flags/az.png": 30883,
	"./flags/ba.png": 11732,
	"./flags/bb.png": 96333,
	"./flags/bd.png": 70857,
	"./flags/be.png": 6089,
	"./flags/bf.png": 94194,
	"./flags/bg.png": 44092,
	"./flags/bh.png": 65581,
	"./flags/bi.png": 17234,
	"./flags/bj.png": 70477,
	"./flags/bl.png": 60681,
	"./flags/bm.png": 20157,
	"./flags/bn.png": 11983,
	"./flags/bo.png": 15419,
	"./flags/bq.png": 4611,
	"./flags/br.png": 71720,
	"./flags/bs.png": 79246,
	"./flags/bt.png": 91391,
	"./flags/bv.png": 64680,
	"./flags/bw.png": 46167,
	"./flags/by.png": 70437,
	"./flags/bz.png": 51673,
	"./flags/ca.png": 23083,
	"./flags/cc.png": 93978,
	"./flags/cd.png": 4462,
	"./flags/cf.png": 20676,
	"./flags/cg.png": 53080,
	"./flags/ch.png": 72049,
	"./flags/ci.png": 47144,
	"./flags/ck.png": 68048,
	"./flags/cl.png": 85678,
	"./flags/cm.png": 87941,
	"./flags/cn.png": 62034,
	"./flags/co.png": 61946,
	"./flags/cr.png": 70243,
	"./flags/cu.png": 5374,
	"./flags/cv.png": 57282,
	"./flags/cw.png": 78878,
	"./flags/cx.png": 59532,
	"./flags/cy.png": 24493,
	"./flags/cz.png": 436,
	"./flags/de.png": 68165,
	"./flags/dj.png": 44669,
	"./flags/dk.png": 38377,
	"./flags/dm.png": 83929,
	"./flags/do.png": 22227,
	"./flags/dz.png": 4412,
	"./flags/ec.png": 58513,
	"./flags/ee.png": 47708,
	"./flags/eg.png": 16817,
	"./flags/er.png": 95823,
	"./flags/es.png": 14695,
	"./flags/et.png": 79051,
	"./flags/fi.png": 36101,
	"./flags/fj.png": 73325,
	"./flags/fk.png": 67631,
	"./flags/flag-01.png": 13691,
	"./flags/flag-02.png": 22688,
	"./flags/flag-03.png": 9701,
	"./flags/flag-04.png": 1462,
	"./flags/flag-05.png": 5645,
	"./flags/fm.png": 57653,
	"./flags/fo.png": 44441,
	"./flags/fr.png": 28823,
	"./flags/ga.png": 34172,
	"./flags/gb.png": 27783,
	"./flags/gd.png": 87814,
	"./flags/ge.png": 88180,
	"./flags/gf.png": 49146,
	"./flags/gg.png": 51062,
	"./flags/gh.png": 95863,
	"./flags/gi.png": 24177,
	"./flags/gl.png": 51893,
	"./flags/gm.png": 42780,
	"./flags/gn.png": 65657,
	"./flags/gp.png": 28403,
	"./flags/gq.png": 31307,
	"./flags/gr.png": 80501,
	"./flags/gs.png": 88471,
	"./flags/gt.png": 51043,
	"./flags/gu.png": 22893,
	"./flags/gw.png": 53470,
	"./flags/gy.png": 27763,
	"./flags/hk.png": 1825,
	"./flags/hn.png": 98081,
	"./flags/hr.png": 90005,
	"./flags/ht.png": 44523,
	"./flags/hu.png": 95269,
	"./flags/id.png": 82328,
	"./flags/ie.png": 45745,
	"./flags/il.png": 67338,
	"./flags/im.png": 12909,
	"./flags/in.png": 52080,
	"./flags/io.png": 82367,
	"./flags/iq.png": 43049,
	"./flags/ir.png": 17715,
	"./flags/is.png": 34401,
	"./flags/it.png": 61955,
	"./flags/je.png": 38536,
	"./flags/jm.png": 59424,
	"./flags/jo.png": 23147,
	"./flags/jp.png": 2615,
	"./flags/ke.png": 57885,
	"./flags/kg.png": 55214,
	"./flags/kh.png": 12822,
	"./flags/ki.png": 37006,
	"./flags/km.png": 63269,
	"./flags/kn.png": 22718,
	"./flags/kp.png": 21756,
	"./flags/kr.png": 39082,
	"./flags/kw.png": 8899,
	"./flags/ky.png": 43174,
	"./flags/kz.png": 67324,
	"./flags/la.png": 44305,
	"./flags/lb.png": 89973,
	"./flags/lc.png": 87591,
	"./flags/li.png": 92577,
	"./flags/lk.png": 16392,
	"./flags/lr.png": 47063,
	"./flags/ls.png": 33753,
	"./flags/lt.png": 70200,
	"./flags/lu.png": 41698,
	"./flags/lv.png": 59167,
	"./flags/ly.png": 52361,
	"./flags/ma.png": 44707,
	"./flags/mc.png": 71325,
	"./flags/md.png": 73351,
	"./flags/me.png": 76294,
	"./flags/mg.png": 74248,
	"./flags/mh.png": 73610,
	"./flags/mk.png": 6721,
	"./flags/ml.png": 26556,
	"./flags/mm.png": 61376,
	"./flags/mn.png": 60555,
	"./flags/mo.png": 83830,
	"./flags/mp.png": 17523,
	"./flags/mq.png": 13431,
	"./flags/mr.png": 73747,
	"./flags/ms.png": 66105,
	"./flags/mt.png": 72293,
	"./flags/mu.png": 15801,
	"./flags/mv.png": 68286,
	"./flags/mw.png": 47015,
	"./flags/mx.png": 90045,
	"./flags/my.png": 68418,
	"./flags/mz.png": 11138,
	"./flags/na.png": 77455,
	"./flags/nc.png": 93902,
	"./flags/ne.png": 3153,
	"./flags/nf.png": 57270,
	"./flags/ng.png": 2565,
	"./flags/ni.png": 27297,
	"./flags/nl.png": 28358,
	"./flags/no.png": 69022,
	"./flags/np.png": 7285,
	"./flags/nr.png": 37111,
	"./flags/nu.png": 94595,
	"./flags/nz.png": 17170,
	"./flags/om.png": 8203,
	"./flags/pa.png": 45290,
	"./flags/pe.png": 72214,
	"./flags/pf.png": 72751,
	"./flags/pg.png": 90929,
	"./flags/ph.png": 42786,
	"./flags/pk.png": 95474,
	"./flags/pl.png": 3435,
	"./flags/pm.png": 90509,
	"./flags/pn.png": 41330,
	"./flags/pr.png": 81198,
	"./flags/ps.png": 57394,
	"./flags/pt.png": 56488,
	"./flags/pw.png": 24057,
	"./flags/py.png": 42547,
	"./flags/qa.png": 85955,
	"./flags/re.png": 25521,
	"./flags/ro.png": 88214,
	"./flags/rs.png": 78786,
	"./flags/ru.png": 74355,
	"./flags/rw.png": 93258,
	"./flags/sa.png": 62390,
	"./flags/sb.png": 8749,
	"./flags/sc.png": 85155,
	"./flags/sd.png": 99799,
	"./flags/se.png": 5201,
	"./flags/sg.png": 93325,
	"./flags/sh.png": 28139,
	"./flags/si.png": 1364,
	"./flags/sk.png": 97482,
	"./flags/sl.png": 65126,
	"./flags/sm.png": 62221,
	"./flags/sn.png": 23501,
	"./flags/so.png": 50664,
	"./flags/sr.png": 52749,
	"./flags/ss.png": 34472,
	"./flags/st.png": 80725,
	"./flags/sv.png": 84402,
	"./flags/sx.png": 28513,
	"./flags/sy.png": 45037,
	"./flags/sz.png": 99226,
	"./flags/tc.png": 76903,
	"./flags/td.png": 61247,
	"./flags/tf.png": 68261,
	"./flags/tg.png": 64664,
	"./flags/th.png": 25525,
	"./flags/tj.png": 77639,
	"./flags/tk.png": 53817,
	"./flags/tl.png": 81533,
	"./flags/tm.png": 57916,
	"./flags/tn.png": 24267,
	"./flags/to.png": 38347,
	"./flags/tr.png": 29960,
	"./flags/tt.png": 74213,
	"./flags/tv.png": 56191,
	"./flags/tw.png": 37434,
	"./flags/tz.png": 27215,
	"./flags/ua.png": 5330,
	"./flags/ug.png": 28001,
	"./flags/um.png": 58259,
	"./flags/us-one.png": 73825,
	"./flags/us.png": 14499,
	"./flags/us1.png": 45885,
	"./flags/uy.png": 1290,
	"./flags/uz.png": 18743,
	"./flags/va.png": 8442,
	"./flags/vc.png": 92094,
	"./flags/ve.png": 71204,
	"./flags/vg.png": 3653,
	"./flags/vi.png": 86544,
	"./flags/vn.png": 27448,
	"./flags/vu.png": 9380,
	"./flags/wf.png": 77970,
	"./flags/ws.png": 72051,
	"./flags/ye.png": 82336,
	"./flags/yt.png": 26221,
	"./flags/za.png": 82516,
	"./flags/zm.png": 93,
	"./flags/zw.png": 6920,
	"./footer-arrow.png": 31862,
	"./footer-fift-bg.png": 8569,
	"./footer-fift-payment.png": 53493,
	"./footer-logo.png": 7917,
	"./footer-logo.svg": 89936,
	"./google-img.svg": 29553,
	"./google-map.png": 26696,
	"./google-play.png": 21317,
	"./google-store-1.png": 82511,
	"./home/home-01.jpg": 84900,
	"./home/home-02.jpg": 68608,
	"./home/home-03.jpg": 87915,
	"./home/home-04.jpg": 66904,
	"./home/home-05.jpg": 96335,
	"./home/home-06.jpg": 38761,
	"./home/home-07.jpg": 98445,
	"./home/home-08.jpg": 56939,
	"./home/home-09.jpg": 70069,
	"./home/home-10.jpg": 75558,
	"./home/home-11.jpg": 14333,
	"./home/home-12.jpg": 29490,
	"./home/home-13.jpg": 99421,
	"./home/home-14.jpg": 65028,
	"./home/home-15.jpg": 30078,
	"./home/home-16.jpg": 8136,
	"./hospital.png": 30685,
	"./icon-01.png": 82577,
	"./icon-02.png": 94849,
	"./icon-03.png": 77757,
	"./icons/Group.png": 81158,
	"./icons/aboutus-icon1.svg": 53001,
	"./icons/add-circle.png": 25522,
	"./icons/admin-icon.svg": 20628,
	"./icons/angry.svg": 71975,
	"./icons/anguish.svg": 56923,
	"./icons/animal-feet-icon.svg": 22256,
	"./icons/app-store-icon.svg": 36027,
	"./icons/app-store.svg": 23629,
	"./icons/atom-bond2.svg": 48633,
	"./icons/badge-check.svg": 63422,
	"./icons/badge.svg": 60237,
	"./icons/ban-img-icon-4.svg": 68748,
	"./icons/ban-img-icon5.svg": 64877,
	"./icons/ban-img-icon6.svg": 84381,
	"./icons/ban-img-icon7.svg": 18207,
	"./icons/ban-img-icon8.svg": 48655,
	"./icons/ban-img-icon9.svg": 49888,
	"./icons/ban-six-icon1.svg": 48541,
	"./icons/ban-six-icon2.svg": 46237,
	"./icons/ban-six-icon3.svg": 63459,
	"./icons/banner-cal-icon.svg": 87764,
	"./icons/bath-tub.svg": 42694,
	"./icons/benefit-icon-01.svg": 52951,
	"./icons/benefit-icon-02.svg": 44210,
	"./icons/benefit-icon-03.svg": 29861,
	"./icons/benefit-icon-04.svg": 37717,
	"./icons/bg-icon-01.svg": 49575,
	"./icons/bg-icon-02.svg": 9931,
	"./icons/book-lab-bg-01.svg": 69472,
	"./icons/book-lab-bg-02.svg": 54663,
	"./icons/bookmark-star.svg": 5602,
	"./icons/bottel.svg": 85674,
	"./icons/browse-01.jpg": 50156,
	"./icons/browse-02.jpg": 36901,
	"./icons/browse-03.jpg": 58668,
	"./icons/browse-04.jpg": 10884,
	"./icons/browse-05.jpg": 51365,
	"./icons/browse-categorie.svg": 62357,
	"./icons/building-icon.svg": 80971,
	"./icons/bullseye.svg": 33726,
	"./icons/calendar3.svg": 1491,
	"./icons/camera.svg": 72952,
	"./icons/cardiology.png": 67686,
	"./icons/care-01.svg": 60055,
	"./icons/care-02.svg": 36198,
	"./icons/care-03.svg": 61318,
	"./icons/care-04.svg": 87237,
	"./icons/care-05.svg": 48321,
	"./icons/care-big-01.svg": 35589,
	"./icons/care-big-02.svg": 11225,
	"./icons/care-big-03.svg": 25545,
	"./icons/care-big-04.svg": 15451,
	"./icons/care-big-05.svg": 49879,
	"./icons/cart-favourite.svg": 86252,
	"./icons/ch.svg": 6374,
	"./icons/check.svg": 73028,
	"./icons/choose-01.svg": 87583,
	"./icons/choose-02.svg": 80604,
	"./icons/choose-03.svg": 89169,
	"./icons/choose-04.svg": 44502,
	"./icons/choose-icon.svg": 4285,
	"./icons/choose-icon1.svg": 62767,
	"./icons/choose-icon2.svg": 20445,
	"./icons/choose-icon3.svg": 55885,
	"./icons/choose-icon4.svg": 14566,
	"./icons/clinic-01.png": 67537,
	"./icons/clinic-02.png": 46314,
	"./icons/clinic-03.png": 77653,
	"./icons/clinic-04.png": 29946,
	"./icons/clinic-05.png": 70555,
	"./icons/clinic-06.png": 39619,
	"./icons/clinic-07.png": 91227,
	"./icons/clinic-08.png": 41523,
	"./icons/clinic-09.png": 95910,
	"./icons/clinic-10.png": 47326,
	"./icons/clinic-11.png": 31294,
	"./icons/clinic-12.png": 1846,
	"./icons/clinic-13.png": 4147,
	"./icons/clinic-hover-01.png": 24927,
	"./icons/clinic-hover-02.png": 42679,
	"./icons/clinic-hover-03.png": 58481,
	"./icons/clinic-hover-04.png": 20603,
	"./icons/clinic-hover-05.png": 68918,
	"./icons/clinic-hover-06.png": 26971,
	"./icons/clinic-hover-07.png": 94466,
	"./icons/clinic-hover-08.png": 88547,
	"./icons/clinic-hover-09.png": 60317,
	"./icons/clinic-hover-10.png": 77582,
	"./icons/comment-icon.svg": 91240,
	"./icons/contact-icon1.svg": 74824,
	"./icons/count-01.svg": 49808,
	"./icons/count-02.svg": 58937,
	"./icons/count-03.svg": 29408,
	"./icons/count-04.svg": 5648,
	"./icons/customer-service-1.svg": 73034,
	"./icons/customer-service-2.svg": 91748,
	"./icons/device-message.svg": 76348,
	"./icons/device-message2.svg": 34567,
	"./icons/discover-1.svg": 11552,
	"./icons/discover-2.svg": 72422,
	"./icons/discover-3.svg": 10996,
	"./icons/discover-4.svg": 42867,
	"./icons/discover-5.svg": 38961,
	"./icons/doc-01.svg": 7394,
	"./icons/doc-02.svg": 56610,
	"./icons/doc-03.svg": 526,
	"./icons/doct-01.png": 80744,
	"./icons/doct-02.png": 93987,
	"./icons/doctor-icon.svg": 82142,
	"./icons/down-arrow-gray-dark.svg": 74980,
	"./icons/down-arrow-gray.svg": 89914,
	"./icons/drugs-svg - Copy.svg": 7795,
	"./icons/drugs-svg.svg": 44525,
	"./icons/drugs.svg": 49620,
	"./icons/edit.svg": 62365,
	"./icons/email-icon.svg": 45107,
	"./icons/email.svg": 91802,
	"./icons/emoj-icon-01.svg": 72369,
	"./icons/emoj-icon-02.svg": 53959,
	"./icons/emoj-icon-03.svg": 56827,
	"./icons/emoj-icon-04.svg": 45475,
	"./icons/emoj-icon-05.svg": 23703,
	"./icons/experience-1.svg": 82514,
	"./icons/experience-2.svg": 99047,
	"./icons/experience-3.svg": 79208,
	"./icons/experience-4.svg": 31587,
	"./icons/experience-5.svg": 76401,
	"./icons/experience-6.svg": 85193,
	"./icons/experience-logo-01.svg": 57769,
	"./icons/experience-logo-02.svg": 15100,
	"./icons/eye-bg.png": 32883,
	"./icons/eye-icon-01.svg": 99696,
	"./icons/eye-icon.svg": 80475,
	"./icons/eye-white-icon.svg": 84554,
	"./icons/eyecare-icon-01.svg": 77882,
	"./icons/eyecare-icon-02.svg": 6329,
	"./icons/eyecare-icon-03.svg": 41963,
	"./icons/facts-1.svg": 65531,
	"./icons/facts-2.svg": 28039,
	"./icons/facts-3.svg": 50109,
	"./icons/facts-4.svg": 671,
	"./icons/facts-5.svg": 25491,
	"./icons/faq-sec-bg-icon.svg": 8427,
	"./icons/fb-icon.svg": 78938,
	"./icons/female.png": 1146,
	"./icons/fifteen-play.svg": 67267,
	"./icons/file.png": 98940,
	"./icons/flow-chart-icon-01.svg": 17849,
	"./icons/flow-chart-icon-02.svg": 66103,
	"./icons/flow-chart-icon-03.svg": 75039,
	"./icons/flow-chart-icon-04.svg": 95869,
	"./icons/fluent-password.svg": 69744,
	"./icons/footer-card-icon-01.svg": 26168,
	"./icons/footer-card-icon-02.svg": 83247,
	"./icons/footer-card-icon-03.svg": 23356,
	"./icons/footer-card-icon-04.svg": 38311,
	"./icons/footer-logo-.svg": 46911,
	"./icons/gem.svg": 49250,
	"./icons/globe.svg": 11909,
	"./icons/google-icon.svg": 17012,
	"./icons/google-play-icon.svg": 16333,
	"./icons/google-play.svg": 17310,
	"./icons/header-icon.svg": 8525,
	"./icons/health-care-1.svg": 74911,
	"./icons/health-care-love - Copy.svg": 47314,
	"./icons/health-care-love.svg": 32835,
	"./icons/healthcare - Copy.svg": 86170,
	"./icons/healthcare.svg": 58371,
	"./icons/heart-2.svg": 66158,
	"./icons/heart-icon.svg": 17305,
	"./icons/heart-pulse-fill.svg": 16437,
	"./icons/heart-pulse.svg": 17512,
	"./icons/heart.svg": 57583,
	"./icons/hex-shape.png": 29410,
	"./icons/hreat-pulse.svg": 50077,
	"./icons/injection.svg": 55479,
	"./icons/instagram-icon.svg": 58987,
	"./icons/insurence-logo-01.svg": 62175,
	"./icons/insurence-logo-02.svg": 44479,
	"./icons/insurence-logo-03.svg": 21831,
	"./icons/insurence-logo-04.svg": 63744,
	"./icons/insurence-logo-05.svg": 82235,
	"./icons/insurence-logo-06.svg": 13226,
	"./icons/lab-service-icon-01.svg": 99673,
	"./icons/lab-service-icon-02.svg": 30966,
	"./icons/lab-service-icon-03.svg": 18119,
	"./icons/lab-view-icon.svg": 75465,
	"./icons/like.svg": 33747,
	"./icons/linkedin-icon.svg": 25015,
	"./icons/lock.svg": 26662,
	"./icons/login-user-circle.svg": 73505,
	"./icons/male.png": 66073,
	"./icons/medal-icon.svg": 94767,
	"./icons/medical-icon-01.svg": 47376,
	"./icons/medical-icon-02.svg": 25590,
	"./icons/medical-icon-03.svg": 4614,
	"./icons/medical-icon-04.svg": 66116,
	"./icons/medicine-icon.svg": 30754,
	"./icons/mic-black.svg": 77478,
	"./icons/mobile-icon.svg": 13895,
	"./icons/mobile.svg": 49298,
	"./icons/nurse-slide-badge-01.svg": 28162,
	"./icons/nurse-slide-badge-02.svg": 22361,
	"./icons/order-icon.svg": 91965,
	"./icons/package-icon-01.svg": 90670,
	"./icons/package-icon-02.svg": 50150,
	"./icons/password-duotone.svg": 70153,
	"./icons/patient-icon.svg": 74089,
	"./icons/payment-card.png": 85554,
	"./icons/payment-icon-01.svg": 26546,
	"./icons/payment-icon-02.svg": 59105,
	"./icons/payment-icon-03.svg": 70766,
	"./icons/payment-icon-04.svg": 43964,
	"./icons/paypal.svg": 45453,
	"./icons/pet-doctor.svg": 15647,
	"./icons/phone-icon.svg": 31248,
	"./icons/phone.png": 53375,
	"./icons/play-01.svg": 69054,
	"./icons/price-icon-04.svg": 69160,
	"./icons/price-icon-05.svg": 64113,
	"./icons/price-icon-06.svg": 88531,
	"./icons/price-icon1.svg": 46402,
	"./icons/price-icon2.svg": 26841,
	"./icons/price-icon3.svg": 64596,
	"./icons/price-sticker-ribbon.svg": 22323,
	"./icons/product-icon-01.svg": 48752,
	"./icons/product-icon-02.svg": 74036,
	"./icons/product-icon-03.svg": 72558,
	"./icons/product-icon-04.svg": 49775,
	"./icons/quatation-img.svg": 51225,
	"./icons/rainbow-1.png": 66377,
	"./icons/rainbow-3.svg": 27230,
	"./icons/rainbow-4.svg": 92617,
	"./icons/rainbow-5.svg": 18696,
	"./icons/review-thumb.svg": 63450,
	"./icons/search-icon.svg": 28356,
	"./icons/section-small-icon-01.svg": 78302,
	"./icons/section-small-icon-02.svg": 44018,
	"./icons/serv-img-icon-1.svg": 24928,
	"./icons/serv-img-icon-2.svg": 5790,
	"./icons/serv-img-icon-3.svg": 14707,
	"./icons/service-01.svg": 97517,
	"./icons/service-02.svg": 98130,
	"./icons/service-03.svg": 28945,
	"./icons/service-04.svg": 46491,
	"./icons/service-05.svg": 92750,
	"./icons/service-06.svg": 65558,
	"./icons/service-07.svg": 96895,
	"./icons/set-cat-01.png": 37405,
	"./icons/set-cat-02.png": 6991,
	"./icons/set-cat-03.png": 20772,
	"./icons/shopping-bag.svg": 89618,
	"./icons/signup-unlock.svg": 20787,
	"./icons/signup-users.svg": 78895,
	"./icons/slider-plugin-icon-01.svg": 7297,
	"./icons/slider-plugin-icon-02.svg": 62369,
	"./icons/slider-plugin-icon-03.svg": 97453,
	"./icons/slider-plugin-icon-04.svg": 7479,
	"./icons/slider-plugin-icon-05.svg": 51259,
	"./icons/slider-plugin-icon-06.svg": 91945,
	"./icons/smart-phone.svg": 51298,
	"./icons/smile-chat.svg": 61320,
	"./icons/smile.svg": 52174,
	"./icons/smiling-icon.svg": 21007,
	"./icons/star.svg": 55548,
	"./icons/sticker-icon.svg": 40507,
	"./icons/stripe.svg": 20178,
	"./icons/success-tick.svg": 99584,
	"./icons/syringe-svg.svg": 30382,
	"./icons/syringe.svg": 57450,
	"./icons/tag-icon.svg": 32361,
	"./icons/test-icon-01.svg": 993,
	"./icons/test-icon-02.svg": 84269,
	"./icons/test-icon-03.svg": 61050,
	"./icons/test-icon-04.svg": 2214,
	"./icons/test-line.svg": 72893,
	"./icons/thumb-icon.svg": 89603,
	"./icons/tick-icon.svg": 40235,
	"./icons/today-icon.svg": 65113,
	"./icons/up-cam.png": 81584,
	"./icons/up-img-1.svg": 71181,
	"./icons/user-circle.svg": 68759,
	"./icons/user-doctor - Copy.svg": 24536,
	"./icons/user-doctor.svg": 44854,
	"./icons/various-logo-01.svg": 98604,
	"./icons/various-logo-02.svg": 17440,
	"./icons/various-logo-03.svg": 41264,
	"./icons/various-logo-04.svg": 60539,
	"./icons/various-logo-05.svg": 2357,
	"./icons/various-logo-06.svg": 44922,
	"./icons/video-icon.svg": 43534,
	"./icons/visit-01.png": 461,
	"./icons/visit-02.png": 94666,
	"./icons/visit-03.png": 85518,
	"./icons/voice.svg": 56164,
	"./icons/watch-icon.svg": 34196,
	"./icons/we-are-icon1.svg": 45477,
	"./icons/we-are-icon2.svg": 97596,
	"./icons/we-are-icon3.svg": 99624,
	"./icons/work-01.svg": 10517,
	"./icons/work-02.svg": 99791,
	"./icons/work-03.svg": 35954,
	"./icons/work-04.svg": 77121,
	"./icons/work-icon-05.svg": 5245,
	"./icons/work-icon-06.svg": 81182,
	"./icons/work-icon-07.svg": 66135,
	"./icons/x-icon-01.png": 82799,
	"./icons/x-icon.svg": 16374,
	"./icons/x-twitter-icon.svg": 99473,
	"./img-01.jpg": 98438,
	"./img-02.jpg": 71921,
	"./img-03.jpg": 50794,
	"./img-04.jpg": 47522,
	"./img-pharmacy1.jpg": 15942,
	"./invoice.png": 96380,
	"./lab-image.jpg": 44826,
	"./location.png": 67085,
	"./login-banner-01.png": 37897,
	"./login-banner.png": 34274,
	"./login-btn.png": 54133,
	"./logo-01.svg": 71234,
	"./logo-03.png": 64507,
	"./logo-15.png": 6581,
	"./logo-dark-blue.svg": 18441,
	"./logo-white.svg": 15700,
	"./logo.png": 15080,
	"./logo.svg": 45522,
	"./mail-box.png": 91911,
	"./maintenance.png": 73903,
	"./map-bg.png": 7958,
	"./marker.png": 77953,
	"./media/media-01.jpg": 2014,
	"./media/media-02.jpg": 16022,
	"./media/media-03.jpg": 52327,
	"./medical-img1.jpg": 88512,
	"./medical-img2.jpg": 96927,
	"./medical-img3.jpg": 3413,
	"./mobile-img.png": 77123,
	"./nurses/nurse-01.jpg": 65870,
	"./nurses/nurse-02.jpg": 32572,
	"./nurses/nurse-03.jpg": 3008,
	"./nurses/nurse-04.jpg": 27544,
	"./nurses/nurse-05.jpg": 89866,
	"./nurses/nurse-06.jpg": 66938,
	"./offer-01.png": 7859,
	"./offer-02.png": 46853,
	"./onboard-img/onb-logo.png": 45655,
	"./onboard-img/onb-slide-img.png": 12068,
	"./partners/partners-1.svg": 81481,
	"./partners/partners-10.svg": 20605,
	"./partners/partners-11.svg": 43604,
	"./partners/partners-12.svg": 22836,
	"./partners/partners-2.svg": 48906,
	"./partners/partners-3.svg": 49410,
	"./partners/partners-4.svg": 92680,
	"./partners/partners-5.svg": 29699,
	"./partners/partners-6.svg": 63498,
	"./partners/partners-7.svg": 87307,
	"./partners/partners-8.svg": 86771,
	"./partners/partners-9.svg": 45315,
	"./patients-img-fifteen.png": 61252,
	"./patients/articles-1.jpg": 57555,
	"./patients/articles-2.jpg": 63537,
	"./patients/articles-3.jpg": 46501,
	"./patients/articles-4.jpg": 59876,
	"./patients/patient-20.jpg": 19239,
	"./patients/patient-21.jpg": 13251,
	"./patients/patient.jpg": 64825,
	"./patients/patient1.jpg": 65266,
	"./patients/patient10.jpg": 52956,
	"./patients/patient11.jpg": 72817,
	"./patients/patient12.jpg": 37860,
	"./patients/patient13.jpg": 87834,
	"./patients/patient14.jpg": 3438,
	"./patients/patient15.jpg": 42416,
	"./patients/patient16.jpg": 30671,
	"./patients/patient17.jpg": 45601,
	"./patients/patient18.jpg": 61434,
	"./patients/patient19.jpg": 93294,
	"./patients/patient2.jpg": 80518,
	"./patients/patient3.jpg": 2594,
	"./patients/patient4.jpg": 90256,
	"./patients/patient5.jpg": 91619,
	"./patients/patient6.jpg": 12163,
	"./patients/patient7.jpg": 5151,
	"./patients/patient8.jpg": 41487,
	"./patients/patient9.jpg": 12365,
	"./payment.png": 19894,
	"./pharmacy-1.png": 14542,
	"./pharmacy-2.png": 8487,
	"./pharmacy-3.png": 19134,
	"./pharmacy-app-bg.png": 85585,
	"./pharmacy-img.png": 62737,
	"./prescription-logo.svg": 53525,
	"./preview-banner.jpg": 86301,
	"./products/product-16.png": 50969,
	"./products/product-17.png": 23414,
	"./products/product-18.png": 79971,
	"./products/product-19.png": 85178,
	"./products/product-20.png": 43599,
	"./products/product-21.png": 49985,
	"./products/product-22.png": 51453,
	"./products/product-23.png": 3855,
	"./products/product-24.png": 877,
	"./products/product-25.png": 75924,
	"./products/product-26.png": 25609,
	"./products/product-27.png": 39912,
	"./products/product-28.png": 98716,
	"./products/product-29.png": 58931,
	"./products/product-30.png": 235,
	"./products/product-31.png": 3899,
	"./products/product-32.png": 4739,
	"./products/product-33.png": 29294,
	"./products/product-34.png": 39077,
	"./products/product.jpg": 64821,
	"./products/product1.jpg": 56554,
	"./products/product10.jpg": 76469,
	"./products/product11.jpg": 75589,
	"./products/product12.jpg": 33451,
	"./products/product13.jpg": 27245,
	"./products/product14.jpg": 24281,
	"./products/product15.jpg": 38644,
	"./products/product2.jpg": 6762,
	"./products/product3.jpg": 83017,
	"./products/product4.jpg": 95951,
	"./products/product5.jpg": 12137,
	"./products/product6.jpg": 49241,
	"./products/product7.jpg": 23269,
	"./products/product8.jpg": 1859,
	"./products/product9.jpg": 8244,
	"./reviews/review-01.jpg": 10819,
	"./reviews/review-02.jpg": 25864,
	"./reviews/review-03.jpg": 64600,
	"./reviews/review-04.jpg": 86469,
	"./reviews/review-img-02.png": 4995,
	"./reviews/review-img-03.png": 6675,
	"./reviews/review-img.png": 40516,
	"./scan-img.png": 68343,
	"./scan.png": 37831,
	"./search-bg.png": 15731,
	"./search.png": 51655,
	"./seller-img.png": 10548,
	"./seller/seller-01.png": 94540,
	"./seller/seller-02.png": 36298,
	"./seller/seller-03.png": 69581,
	"./seller/seller-04.png": 91901,
	"./seller/seller-05.png": 98893,
	"./seller/seller-06-.png": 7932,
	"./seller/seller-06.png": 11612,
	"./seller/seller-07.png": 58736,
	"./seller/seller-08.png": 1422,
	"./seller/seller-09.png": 78380,
	"./seller/seller-10.png": 40276,
	"./seller/seller-11.png": 68077,
	"./seller/seller-12.png": 83250,
	"./seller/seller-13.png": 92327,
	"./seller/seller-14.png": 27800,
	"./seller/seller-15.png": 71883,
	"./sending-img.jpg": 66838,
	"./serive-bg-icon.png": 46004,
	"./service-six-1.jpg": 9214,
	"./service-six-2.jpg": 10050,
	"./service-six-3.jpg": 14907,
	"./service-six-4.jpg": 86194,
	"./service-sixteen-icon.png": 40113,
	"./service/dentist-01.jpg": 5204,
	"./service/dentist-02.jpg": 69813,
	"./service/dentist-03.jpg": 60645,
	"./service/dentist-04.jpg": 71781,
	"./service/fertility-01.jpg": 11783,
	"./service/fertility-02.jpg": 75676,
	"./service/fertility-03.jpg": 78726,
	"./service/fertility-04.jpg": 93784,
	"./service/fertility-05.jpg": 39983,
	"./service/footer-img-01.jpg": 4078,
	"./service/footer-img-02.jpg": 724,
	"./service/footer-img-03.jpg": 54234,
	"./service/footer-img-04.jpg": 68643,
	"./service/service-1.jpg": 44105,
	"./service/service-2.jpg": 38856,
	"./service/service-3.jpg": 41177,
	"./service/service-doctor-01.jpg": 50445,
	"./service/service-doctor-02.jpg": 28967,
	"./service/service-doctor-03.jpg": 17143,
	"./service/service-doctor-04.jpg": 77246,
	"./service/service-doctor-05.jpg": 47807,
	"./service/service-doctor-06.jpg": 4985,
	"./service/service-doctor-07.jpg": 44627,
	"./service/service-doctor-08.jpg": 29512,
	"./service/service-doctor-09.jpg": 19316,
	"./service/service-doctor-10.jpg": 93819,
	"./service/service-img-01.jpg": 7653,
	"./service/service-img-02.jpg": 10162,
	"./service/service-img.jpg": 57310,
	"./service/treatment-01.jpg": 13417,
	"./service/treatment-02.jpg": 90677,
	"./service/treatment-03.jpg": 21181,
	"./service/treatment-04.jpg": 18365,
	"./service/treatment-05.jpg": 47076,
	"./service/treatment-1.jpg": 78438,
	"./service/treatment-2.jpg": 56503,
	"./service/treatment-3.jpg": 72641,
	"./service/treatment-4.jpg": 24115,
	"./services-six-1.png": 23848,
	"./shape-01.png": 78164,
	"./shape-02.png": 67051,
	"./shape-03.png": 18210,
	"./shape-04.png": 82275,
	"./shape-05.png": 24900,
	"./shape-06.png": 22650,
	"./shape-07.png": 27503,
	"./shapes/2 561.png": 92085,
	"./shapes/Ellipse 7.png": 4917,
	"./shapes/Ellipse 8.png": 41891,
	"./shapes/alarm.png": 17657,
	"./shapes/blog-img01.jpg": 35074,
	"./shapes/blog-img01.png": 73078,
	"./shapes/blog-img02.jpg": 47194,
	"./shapes/blog-img03.jpg": 9736,
	"./shapes/bro-01.png": 98479,
	"./shapes/bro-02.png": 88796,
	"./shapes/bro-03.png": 88373,
	"./shapes/bro-04.png": 54145,
	"./shapes/bro-05.png": 30283,
	"./shapes/circle-left.png": 46461,
	"./shapes/circle-right.png": 9738,
	"./shapes/clinic-bg.png": 66712,
	"./shapes/consult.png": 95663,
	"./shapes/doc-img-01.jpg": 47414,
	"./shapes/doctor-bg.jpg": 34793,
	"./shapes/doctor-right-bg.jpg": 76427,
	"./shapes/exper.png": 98978,
	"./shapes/graph-01.png": 2834,
	"./shapes/graph-02.png": 37003,
	"./shapes/graph-03.png": 35237,
	"./shapes/graph-04.png": 20461,
	"./shapes/map-plus.png": 31660,
	"./shapes/shape-1.png": 84008,
	"./shapes/shape-10.png": 68803,
	"./shapes/shape-11.png": 7679,
	"./shapes/shape-12.png": 20373,
	"./shapes/shape-2.png": 60324,
	"./shapes/shape-3.png": 26461,
	"./shapes/shape-4.png": 40974,
	"./shapes/shape-5.png": 32088,
	"./shapes/shape-6.png": 34,
	"./shapes/shape-7.png": 93033,
	"./shapes/shape-8.png": 38917,
	"./shapes/shape-9.png": 66064,
	"./shapes/spec-01.png": 62313,
	"./shapes/spec-02.png": 69613,
	"./shapes/spec-03.png": 27646,
	"./shapes/spec-04.png": 93219,
	"./shapes/spec-05.png": 48815,
	"./shapes/spec-06.png": 35947,
	"./shapes/spec-07.png": 56332,
	"./shapes/spec.png": 39722,
	"./slide1.jpg": 41420,
	"./slide2.jpg": 18371,
	"./slider-bg.jpg": 26218,
	"./slider/banner-01.jpg": 35036,
	"./slider/banner-02.jpg": 51346,
	"./slider/blue-bg.png": 90301,
	"./slider/book-doc-01.jpg": 29615,
	"./slider/doctor-bg.jpg": 79927,
	"./slider/doctor1-bg.jpg": 99781,
	"./slider/feature-bg.jpg": 46684,
	"./slider/feature-img.jpg": 50035,
	"./slider/patient-bg.jpg": 83566,
	"./slider/patient1-bg.jpg": 17473,
	"./slider/slider-1.jpg": 85266,
	"./slider/slider-2.jpg": 92693,
	"./slider/slider-3.jpg": 7255,
	"./slider/slider-4.jpg": 57109,
	"./slider/slider-5.jpg": 7487,
	"./slider/slider-6.jpg": 59854,
	"./slider/slider-7.jpg": 83709,
	"./slider/swiper-slide-img-01.jpg": 72385,
	"./slider/swiper-slide-img-02.jpg": 23784,
	"./slider/swiper-slide-img-03.jpg": 52626,
	"./slider/video-slider-img-01.jpg": 76277,
	"./slider/video-slider-img-02.jpg": 63194,
	"./slider/video-slider-img-03.jpg": 25881,
	"./slider/video-slider-img-04.jpg": 38502,
	"./slider/video-slider-thumb-01.jpg": 79103,
	"./slider/video-slider-thumb-02.jpg": 7233,
	"./slider/video-slider-thumb-03.jpg": 94752,
	"./special-banner.jpg": 99291,
	"./specialist-bg.jpg": 29383,
	"./specialities/pt-dashboard-01.png": 94154,
	"./specialities/pt-dashboard-02.png": 29281,
	"./specialities/pt-dashboard-03.png": 89273,
	"./specialities/pt-dashboard-04.png": 3093,
	"./specialities/specialities-01.png": 65488,
	"./specialities/specialities-01.svg": 77964,
	"./specialities/specialities-02.png": 99022,
	"./specialities/specialities-02.svg": 5031,
	"./specialities/specialities-03.png": 25326,
	"./specialities/specialities-03.svg": 48404,
	"./specialities/specialities-04.png": 21080,
	"./specialities/specialities-04.svg": 11178,
	"./specialities/specialities-05.png": 48761,
	"./specialities/specialities-05.svg": 35555,
	"./specialities/specialities-06.svg": 82056,
	"./stores/store-01.jpg": 75611,
	"./stores/store-02.jpg": 75846,
	"./stores/store-03.jpg": 56509,
	"./stores/store-04.jpg": 19737,
	"./stores/store-05.jpg": 35811,
	"./stores/store-06.jpg": 17139,
	"./stores/store-07.jpg": 15752,
	"./stores/store-08.jpg": 76690,
	"./stores/store-09.jpg": 19977,
	"./stores/store-10.jpg": 37029,
	"./stores/store-11.jpg": 83270,
	"./stores/store-12.jpg": 29202,
	"./stores/store-13.jpg": 9350,
	"./stores/store-14.jpg": 62050,
	"./stores/store-15.jpg": 34695,
	"./stores/store-16.jpg": 15031,
	"./testimonial-2.jpg": 41715,
	"./testimonial.jpg": 74057,
	"./testimonialicon-2.png": 535,
	"./treatment-1.jpg": 30163,
	"./treatment-2.jpg": 25527,
	"./treatment-3.jpg": 49582,
	"./treatment-4.jpg": 32653,
	"./trusted-img.jpg": 87570,
	"./trusted-img.png": 18055,
	"./upload-icon.png": 20390,
	"./veterinary-home-logo.svg": 48674,
	"./video-call.jpg": 41625,
	"./way-img.png": 79061,
	"./welcome-icon.png": 67010,
	"./welcome-icon1.png": 11888,
	"./work-img.png": 82009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;